export default function CandidateLoadingCard() {
  return (
    <div className="flex flex-col gap-md bg-white p-xl shadow-[0px_0px_2px_0px_rgba(0,_0,_0,_0.20)]">
      <div className="flex">
        <div className="flex flex-col gap-md">
          <div className="h-lg w-[248px] animate-skeleton rounded-full bg-gray_darken"></div>
          <div className="h-[10px] w-[452px] animate-skeleton rounded-full bg-gray_darken"></div>
        </div>
        <div className="ml-auto flex gap-md">
          {Array.from({ length: 5 }).map((_, key) => {
            return (
              <div
                key={key}
                className="h-[68px] w-[80px] animate-skeleton rounded-xs bg-gray_darken"
              ></div>
            );
          })}
        </div>
      </div>
      <div className="flex gap-md">
        {Array.from({ length: 5 }).map((_, key) => {
          return (
            <div
              key={key}
              className="h-lg w-[84px] animate-skeleton rounded-full bg-gray_darken"
            ></div>
          );
        })}
      </div>
      <div className="flex flex-col gap-md">
        <div className="h-[10px] animate-skeleton rounded-full bg-gray_darken"></div>
        <div className="h-[10px] animate-skeleton rounded-full bg-gray_darken"></div>
      </div>
    </div>
  );
}
